import { isDefined } from "@omni/utils/helper.utils";
import { createContext, Dispatch, ReactNode, SetStateAction, use } from "react";

import { FlyoutCategory } from "@/redux/modules/value/flyoutCategories/flyoutCategories.types";

type CategorySlideContextValue = {
    category: FlyoutCategory;
    closing: boolean;
    setClosing: Dispatch<SetStateAction<boolean>>;
};

type CategorySlideContextProviderProps = {
    category: FlyoutCategory;
    closing: boolean;
    setClosing: Dispatch<SetStateAction<boolean>>;
    children: ReactNode;
};

export const CategorySlideContext = createContext<
    CategorySlideContextValue | undefined
>(undefined);
CategorySlideContext.displayName = "CategorySlideContext";

export const CategorySlideContextProvider = ({
    category,
    closing,
    setClosing,
    children
}: CategorySlideContextProviderProps) => {
    return (
        <CategorySlideContext
            value={{
                category: category,
                closing: closing,
                setClosing: setClosing
            }}
        >
            {children}
        </CategorySlideContext>
    );
};

export const useCategorySlideContext = () => {
    const context = use<CategorySlideContextValue | undefined>(
        CategorySlideContext
    );

    if (!isDefined(context)) {
        throw new Error(`${CategorySlideContext.displayName} is undefined.`);
    }

    return context;
};
